import request from '@/utils/request.js'
/**
 * 
 * @param {string} ganeName 应用两名
 * @param {string} language 语言简称
 * @param {string} id 加密id
 */
export function loadAccountSection(id, language, platform) {
    if (checkBeforeRequest(id, language, platform)) {
        return Promise.reject()
    }
    return request({
        method: 'get',
        // url: '/api/mfaq/loadaccountsection',
        url: '/elva/api/mfaq/loadaccountsection',
        // url: 'https://aihelp.net/elva/api/mfaq/loadaccountsection',
        params: {
            accountIdKey: id,
            alias: language,
            platform
        }
    })
}

/**
 * 获取faqList
 * @param {Object} param 参数对象
 */
export function loadFaqList(
    alias,
    key,
    sectionIdKey,
    platform
) {
    if (checkBeforeRequest(alias, key, sectionIdKey, platform)) {
        return Promise.reject()
    }
    return request({
        method: 'get',
        // url: '/api/mfaq/loadlist',
        url: '/elva/api/mfaq/loadlist',
        // url: 'https://aihelp.net/elva/api/mfaq/loadlist',
        params: {
            gameIdKey: key,
            sectionIdKey: sectionIdKey,
            alias: alias,
            platform
        }
    })
}

/**
 * 获取faq详情
 * @param {Object} param 参数对象
 */
export function loadFaqDetail(
    key,
    sectionIdKey,
    kmContentIdKey,
    alias,
    platform
) {
    if (checkBeforeRequest(key, sectionIdKey, kmContentIdKey, alias, platform)) {
        return Promise.reject()
    }
    return request({
        method: 'get',
        // url: '/api/mfaq/loaddetail',
        url: '/elva/api/mfaq/loaddetail',
        // url: 'https://aihelp.net/elva/api/mfaq/loaddetail',
        params: {
            gameIdKey: key,
            sectionIdKey,
            kmContentIdKey,
            alias,
            platform
        }
    })
}

/**
 * 获取app FAQ section
 * @param {Object} param 参数对象
 */
export function loadAppFaqSection(
    key,
    alias,
    platform
) {
    if (checkBeforeRequest(key, alias, platform)) {
        return Promise.reject()
    }
    return request({
        method: 'get',
        // url: '/api/mfaq/loadgamesection',
        url: '/elva/api/mfaq/loadgamesection',
        // url: 'https://aihelp.net/elva/api/mfaq/loadgamesection',
        params: {
            gameIdKey: key,
            alias,
            platform
        }
    })
}

/**
 * 搜索
 * @param {Object} param 参数对象
 */
export function searchFAQ(
    keyWords,
    key,
    alias,
    platform
) {
    if (checkBeforeRequest(keyWords, key, alias, platform))  return Promise.reject()
    return request({
        method: 'get',
        // url: '/api/mfaq/search',
        url: '/elva/api/mfaq/search',
        // url: 'https://aihelp.net/elva/api/mfaq/search',
        params: {
            keyWords,
            gameIdKey: key,
            alias,
            platform
        }
    })
}

/**
 * 搜索
 * @param {Object} param 参数对象
 */
export function contactUs(data) {
    return request({
        method: 'post',
        // url: '/api/chat/createmail',
        url: '/elva/api/chat/createmail',
        // url: 'https://aihelp.net/elva/api/chat/createmail',
        data
    })
}

function checkBeforeRequest(...params) {
    return params.some(item => {
        return item === undefined || item == 'undefined'
    })
}